import { OnsiteCampaignStatus } from 'sections/onsite-campaigns/types';
import { CampaignSettingsAction, CampaignSettingsState } from './CampaignSettingsState';

export const CampaignSettingsReducer = (state: CampaignSettingsState, action: CampaignSettingsAction) => {
  switch (action.type) {
    case 'SET_CAMPAIGN_STATUS': {
      return {
        ...state,
        status: action.payload.status as OnsiteCampaignStatus,
      };
    }
    case 'SET_CAMPAIGN_NAME': {
      return {
        ...state,
        name: action.payload.name,
      };
    }
    case 'SET_CAMPAIGN_ALLOWLIST': {
      return {
        ...state,
        allowList: JSON.parse(JSON.stringify(action.payload.allowList)),
      };
    }
    case 'SET_EMAIL_ALLOW_LIST': {
      return {
        ...state,
        emailAllowList: action.payload.allowedEmails,
      };
    }
    case 'SET_LOOKBACK_PERIOD': {
      return {
        ...state,
        lookBackPeriodInMinutes: action.payload.lookBackPeriodInMinutes,
      };
    }
    case 'SET_CAMPAIGN_START_DATE': {
      return {
        ...state,
        scheduling: {
          ...state.scheduling,
          startDate: action.payload.startDate,
        },
      };
    }
    case 'SET_CAMPAIGN_START_TIME': {
      return {
        ...state,
        scheduling: {
          ...state.scheduling,
          startTime: action.payload.startTime,
        },
      };
    }
    case 'SET_CAMPAIGN_END_DATE': {
      const defaultTime = '23:59';
      let endTime = state.scheduling.endTime ?? defaultTime;
      if (!action.payload.endDate) {
        endTime = defaultTime;
      }

      return {
        ...state,
        scheduling: {
          ...state.scheduling,
          endDate: action.payload.endDate,
          endTime,
        },
      };
    }
    case 'SET_CAMPAIGN_END_TIME': {
      return {
        ...state,
        scheduling: {
          ...state.scheduling,
          endTime: action.payload.endTime,
        },
      };
    }
    default:
      return state;
  }
};
